import EconomicMissingOrdersViewModel from "../Models/ViewModels/EconomicErrorViewModel";
import PageModel from "../Models/ViewModels/PageModel";
import MakeRequest from "../Utilities/MakeRequest";
    
export function fetchEconomicMissingOrdersList(currentPage: number, pageSize: number): Promise<PageModel<EconomicMissingOrdersViewModel>> {
    return new Promise<PageModel<EconomicMissingOrdersViewModel>>((resolve, reject) => {
        new MakeRequest(`/api/economicMissingOrders?Page=${currentPage}&Size=${pageSize}`)
            .send()
            .then((response: string) => {
                resolve(JSON.parse(response));
            }, reject);
    });
}

export function retryInvoicingStoresWithMissingOrders(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        new MakeRequest(`/api/economicMissingOrders/retryInvoicingStoresWithMissingOrders`)
            .send()
			.then(resolve, reject);
    });
}